import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import Paper from "commons/ui/Paper";

import useApartmentRatesForm from "hooks/form/useApartmentRatesForm";

function ApartmentRatesForm() {
    const { formHook } = useApartmentRatesForm();

    const { checkErrorVisibility, setValue, form } = formHook;

    return (
        <GridColumn>
            <Paper>
                <GridColumn>
                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Importo minimo per appartamento</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-6"}>
                            <InputText
                                label={"Terrazza - Importo minimo (€)"}
                                value={form.terrazza}
                                setValue={setValue}
                                path={"terrazza"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-12-6"}>
                            <InputText
                                label={"Retica - Importo minimo (€)"}
                                value={form.retica}
                                setValue={setValue}
                                path={"retica"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>
                </GridColumn>
            </Paper>
        </GridColumn>
    );
}

export default ApartmentRatesForm;
